import type { TypeSubmenuConfig } from './types';

import { merge } from '../../helper';

import * as exDropdown from './index';

// ----------------------------------------------------------------------------

function create(config: TypeSubmenuConfig = {}): any {
    // Default Config
    const defConfig = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Create element (dropdown submenu)
    const dropdownSubmenu = exDropdown.create({
        merge: defConfig,
        tag: 'li',
        class: {
            new: 'dropdown-submenu',
        },
        submenu: true,
    }) as any;

    // ------------------------------------------------------------------------

    // Return
    return dropdownSubmenu;
}

// ----------------------------------------------------------------------------

export { create };
